import {
  AnimationHandler,
  Tile,
  TileImage,
  HoverHandler,
} from '@mc/design-system'
import Image from 'components/LegacyImage'
import Link from 'components/Link'
import { trackTileClick } from '../events'
import { type AnnouncementTileProps } from './types'

export const AnnouncementTile = ({
  tile,
  carouselSlug,
  location,
  onClick = trackTileClick,
  openNewPage = false,
  isPrioritized = false,
}: AnnouncementTileProps) => (
  <HoverHandler>
    {({ hovering: isHovering, focused }) => (
      <Link
        href={tile.link}
        passHref
        newTab={openNewPage}
        onClick={() => {
          onClick({
            classTitle: tile.title,
            carouselSlug,
            location,
            link: tile.link,
          })
        }}
      >
        <Tile aspectRatio='9x16' className='mc-corners--sm mc-overflow--hidden'>
          <AnimationHandler type='zoom' animating={isHovering || focused}>
            <TileImage
              image={
                <Image
                  alt={tile.title || ''}
                  src={tile.backgroundImage!}
                  width={395}
                  height={702}
                  priority={isPrioritized}
                />
              }
            />
          </AnimationHandler>
        </Tile>
      </Link>
    )}
  </HoverHandler>
)
